import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, onMounted } from "vue";
import { ChartData, ChartOptions } from "chart.js/auto";
import Chart from "../../base-components/Chart";
import { getColor } from "../../utils/colors";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportDonutChart1',
  props: {
    width: null,
    height: null
  },
  setup(__props: any) {

const props = __props as {
  width?: number;
  height?: number;
}

const refresh = ref(0);
onMounted(() => {
  refresh.value++;
});

window.addEventListener("updateTheme", (event) => {
  refresh.value++;
});



const chartData = [15, 10, 65];
const chartColors = () => {
  //return ["rgb( 234 88 12 / 0.9)", "rgb( 234 179 8 / 0.9)", "rgb( 153 27 27 / 0.9)"]

  return [
    getColor("pending", 0.9),
    getColor("warning", 0.9),
    getColor("primary", 0.9),
  ];
};

function calculateData() {
  //@ts-ignore
  const darkMode = JSON.parse(localStorage.getItem("theme")).darkMode;
  //@ts-ignore
  const colorScheme = JSON.parse(localStorage.getItem("theme")).colorScheme;
  return {
    labels: ["Yellow", "Dark"],
    datasets: [
      {
        data: chartData,
        backgroundColor: colorScheme ? chartColors() : "",
        hoverBackgroundColor: colorScheme ? chartColors() : "",
        borderWidth: 2,
        borderColor: darkMode ? getColor("darkmode.700") : getColor("white"),
      },
    ],
  };
}

const options = computed<ChartOptions>(() => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: "83%",
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Chart), {
    key: refresh.value,
    type: "doughnut",
    width: props.width,
    height: props.height,
    data: calculateData(),
    options: _unref(options)
  }, null, 8, ["width", "height", "data", "options"]))
}
}

})